import { useEffect, useState } from 'react';
import SiteNavbar from '@/components/feature/SiteNavbar';
import SiteFooter from '@/components/feature/SiteFooter';
import Hero from './components/Hero';
import Ticker from './components/Ticker';
import HotRanking from './components/HotRanking';
import LatestScoops from './components/LatestScoops';
import DigZones from './components/DigZones';
import ChatExpose from './components/ChatExpose';
import DeepTrack from './components/DeepTrack';
import SubmitCta from './components/SubmitCta';

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 720);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <button
      type="button"
      aria-label="回到顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-foreground-950 text-background-50 flex items-center justify-center hover:bg-primary-600 transition-colors cursor-pointer"
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteNavbar />
      <main>
        <Hero />
        <Ticker />
        <HotRanking />
        <LatestScoops />
        <DigZones />
        <ChatExpose />
        <DeepTrack />
        <SubmitCta />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}